<script>
  import { onMount } from 'svelte';
  import { getHexToRgbColor } from '../../etc/utils';

  //-----------Var Inits--------------

  let canvas = null;
  let ctx = {};
  let cx = 0;
  let cy = 0;

  let confetti = [];
  const confettiCount = 170;
  const gravity = 1;
  const terminalVelocity = 1.4;
  const drag = 0.2;
  const colors = [
    { front: '#67D6B3', back: '#67D6B3' },
    { front: '#FFD075', back: '#FFD075' },
    { front: '#9ACFFF', back: '#9ACFFF' },
    { front: '#C5CBFF', back: '#C5CBFF' },
    { front: '#1877CC', back: '#1877CC' },
    { front: '#F26E6E', back: '#F26E6E' },
    { front: '#33CDF0', back: '#33CDF0' }
  ];
  let isFalling = false;

  //-----------Functions--------------
  const resizeCanvas = () => {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    cx = ctx.canvas.width / 2;
    cy = ctx.canvas.height / 2;
  };

  const randomRange = (min, max) => Math.random() * (max - min) + min;

  const initConfetti = () => {
    canvas = document.getElementById('animation-canvas-confetti');
    ctx = canvas.getContext('2d');
    const element = document.getElementsByClassName(
      'twism-popup-gotcoins--header'
    )[0];
    canvas.width = element.offsetWidth;
    canvas.height = 170;
    cx = ctx.canvas.width / 2;
    cy = ctx.canvas.height / 2;
    for (let i = 0; i < confettiCount; i++) {
      confetti.push({
        color: colors[Math.floor(randomRange(0, colors.length))],
        dimensions: {
          x: randomRange(5, 10),
          y: randomRange(5, 15)
        },
        position: {
          x: randomRange(0, canvas.width),
          y: canvas.height - 1
        },
        rotation: randomRange(0, 2 * Math.PI),
        scale: {
          x: 1,
          y: 1
        },
        velocity: {
          x: randomRange(-25, 25),
          y: randomRange(0, -50)
        }
      });
    }
  };

  //---------Render-----------
  const render = () => {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    confetti.forEach((confetto, index) => {
      let width = confetto.dimensions.x * confetto.scale.x;
      let height = confetto.dimensions.y * confetto.scale.y;

      // Move canvas to position and rotate
      ctx.translate(confetto.position.x, confetto.position.y);
      ctx.rotate(confetto.rotation);

      // Apply forces to velocity
      confetto.velocity.x -= confetto.velocity.x * drag;
      confetto.velocity.y = Math.min(
        confetto.velocity.y + gravity,
        terminalVelocity
      );
      confetto.velocity.x +=
        Math.random() > 0.5 ? Math.random() : -Math.random();

      // Set position
      confetto.position.x += confetto.velocity.x;
      confetto.position.y += confetto.velocity.y;

      // Delete confetti when out of frame
      if (confetto.position.y >= canvas.height) confetti.splice(index, 1);

      // Loop confetto x position
      if (confetto.position.x > canvas.width) confetto.position.x = 0;
      if (confetto.position.x < 0) confetto.position.x = canvas.width;

      // Spin confetto by scaling y
      confetto.scale.y = Math.cos(confetto.position.y * 0.1);
      const color =
        confetto.scale.y > 0 ? confetto.color.front : confetto.color.back;
      const rgb = getHexToRgbColor(color);
      let opacity = 1;

      const fromBottom = canvas.height - confetto.position.y;

      if (fromBottom < 100 && isFalling) {
        opacity = fromBottom / 100;
      }

      ctx.fillStyle = `rgba(${rgb}, ${opacity})`;
      // Draw confetto
      ctx.fillRect(-width / 2, -height / 2, width, height);
      // Reset transform matrix
      ctx.setTransform(1, 0, 0, 1, 0, 0);
    });

    // Fire off another round of confetti
    // if (confetti.length <= 10) initConfetti();

    window.requestAnimationFrame(render);
  };

  onMount(() => {
    setTimeout(() => {
      initConfetti();
      render();
      setTimeout(() => {
        isFalling = true;
      }, 100);
    }, 500);
  });
</script>

<div class="animation-wrapper">
  <canvas id="animation-canvas-confetti" />
</div>

<style lang="scss">
  .animation-wrapper {
    pointer-events: none;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 170px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    z-index: 0;
  }
</style>
